const date = new Date();
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
let currMonth = months[date.getMonth()];
let day = date.getDate();
let month = date.getMonth() + 1;
let year = date.getFullYear();

let currentDate = `${month}/${day}/${year}`;
let currentDateForTransfer = `${day}.${month}.${year}`;
export { currentDate, currentDateForTransfer, currMonth, year, month, months };

export function getFormattedDateKST() {
  const now = new Date();

  // Convert to Korea time (UTC+9)
  const koreaTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));

  const month = koreaTime.toLocaleString('en-US', { month: 'short' });
  const day = koreaTime.getDate().toString().padStart(2, ' ');
  const year = koreaTime.getFullYear();

  let hours = koreaTime.getHours();
  const minutes = koreaTime.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${month} ${day} ${year} ${hours}:${minutes}${ampm} KST`;
}
